import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { STORAGE_URL } from "constants";
import { useLanguage } from "hooks";
import { Icons } from "components";
import moment from "moment";

// This component has been built for: Displays links to specific types of books: curricula and magazines together

export default function Archives({
  links, // book links --> array of object
  setStep, // to set the step on user click the back button call to go the step 1 if to the show the Book button (magazine) go to step 2 with and set the link as the current link
  setLink, //to set the current link "when user click show the Book"
  mainImage, // if curriculum don't have a cover image it gonna use main image
  type = "magazine", // type by default magazine that control link display view
}) {
  const language = useLanguage(); //language returned from useLanguage hook; it’s an object with current language key --> "value in current language";

  return (
    <section className="mb-3">
      <Container>
        <Row className="g-4">
          <Col xs={6}>
            <h1 className="fw-medium text-primary cut-text-2">
              {language.archives}
            </h1>
          </Col>
          <Col xs={6} className="text-end">
            <button
              onClick={() => setStep(1)}
              className={`btn btn-outline-primary `}
            >
              {language.back}
            </button>
          </Col>
          {links.map((link) => (
            <Col xl={3} lg={4} md={6} sm={6} xs={12}>
              {type === "curriculum" && (
                <div className="book_card position-relative bg-light rounded-4">
                  <div className="px-4 mb-2">
                    <div className="d-flex justify-content-center px-3 mb-2 book-img">
                      <img
                        src={`${STORAGE_URL}${
                          link.cover_image === null
                            ? mainImage
                            : link.cover_image
                        }`}
                        title="figure"
                        alt={link.title}
                      />
                      {/* STORAGE_URL link to the place we save the data (images, pdf documents, ... ) */}
                    </div>

                    <Row>
                      <Col xs={12}>
                        <ul className="links_types-ul list-group list-group-horizontal bg-transparent gap-2">
                          <li className="d-flex align-items-center justify-content-center bg-transparent gap-1 border-0 p-0">
                            <img
                              src={`${STORAGE_URL}${link.type?.icon}`}
                              width="25"
                              height="25"
                              alt={link.type?.type}
                            />
                            <p className="fw-normal text-light3 py-0 my-0">
                              {link.type?.type}{" "}
                              {/* type of the type of the link (pdf, sound...) type smaller */}
                            </p>
                          </li>
                        </ul>
                      </Col>
                      <Col xs={12}>
                        <h5 className="fw-bold text-black cut-text-2 h6 description">
                          {link.type?.name}{" "}
                          {/* name of the type of the link (pdf, sound...) */}
                        </h5>
                      </Col>
                    </Row>
                  </div>
                  <a
                    onClick={(e) => setLink(e, link)}
                    className="position-absolute end-0 start-0 bottom-0"
                  >
                    <div className="view_button user-select-none px-4 py-1 bg-light2">
                      <Row className="align-items-center">
                        <Col xl={10} lg={10} md={10} sm={10} xs={10}>
                          <h6 className="fw-bold m-0">
                            {language.showtheBook}
                          </h6>
                        </Col>
                        <Col xl={2} lg={2} md={2} sm={2} xs={2}>
                          <Icons.ArrowLeft />
                        </Col>
                      </Row>
                    </div>
                  </a>
                </div>
              )}
              {type === "magazine" && (
                <div
                  key={link.id}
                  className="multimedia_card position-relative border border-1 border-light3 pt-5 rounded-4"
                >
                  <div className="px-4 mb-3">
                    <div className="d-flex justify-content-center mb-3">
                      <div className="img-container d-flex align-items-center justify-content-center">
                        <img
                          src={`${STORAGE_URL}${link.cover_image}`}
                          title="figure"
                          alt={link.edition_no}
                        />
                      </div>
                    </div>

                    <h5 className="fw-bold text-black cut-text-2 h6 description">
                      {language.editionNo}: {link.edition_no}
                    </h5>
                    <p className="fw-normal text-light4 cut-text-1 ">
                      {language.date}:
                      {moment(link.publishing_date).format("YYYY")}{" "}
                      {/** take just the year from publishing_date  */}
                    </p>
                  </div>

                  <button
                    className="position-absolute end-0 start-0 bottom-0 btn p-0"
                    onClick={() => {
                      setStep(2);
                      setLink(link);
                    }}
                  >
                    <div className="view_button user-select-none px-4 py-2 bg-light2">
                      <Row className="align-items-center">
                        <Col xl={10} lg={10} md={10} sm={10} xs={10}>
                          <h6 className="fw-bold">{language.showtheBook}</h6>
                        </Col>
                        <Col xl={2} lg={2} md={2} sm={2} xs={2}>
                          <Icons.ArrowLeft />
                        </Col>
                      </Row>
                    </div>
                  </button>
                </div>
              )}
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}
